import Form from '@components/form/Form';
import FormRow from 'lib/src/components/form/FormRow';
import TextInput from '@components/form/TextInput';
import Checkbox from '@components/form/Checkbox';
import Modal from '@components/modal/Modal';
import { tagTypes } from 'lib/src/shared/enums/tagTypes';
import useCreateTag from './hooks/useCreateTag';

const CreateTagModal = ({ type }: CreateTagModalProps) => {
    const {
        handleSubmit,
        handleChange,
        closeModal,
        isPosting,
        formState: { name, isPublic },
    } = useCreateTag(type);

    return (
        <Modal title="Create Tag" size="small" closeModal={closeModal}>
            <Form onCancel={closeModal} onSubmit={handleSubmit} isPosting={isPosting}>
                <FormRow>
                    <TextInput
                        name="name"
                        value={name}
                        onChange={handleChange}
                        label="Name"
                        placeholder="Name of this tag"
                        required
                    />
                </FormRow>

                <FormRow>
                    <Checkbox
                        name="isPublic"
                        label="Is public?"
                        value={isPublic}
                        onChange={handleChange}
                    />
                </FormRow>
            </Form>
        </Modal>
    );
};

interface CreateTagModalProps {
    type: tagTypes;
}
export default CreateTagModal;
